import { useQuery } from '@tanstack/react-query'
import { Redirect, useLocalSearchParams } from 'expo-router'
import ScreenView from '~/components/layout/ScreenView'
import { LoadingView } from '~/components/LoadingView'
import { trpc } from '~/lib/trpc'

export default function FeedbackShortId() {
  return (
    <ScreenView>
      <FeedbackContent />
    </ScreenView>
  )
}

function FeedbackContent() {
  const { feedbackShortId } = useLocalSearchParams<{
    feedbackShortId: string
  }>()

  const { data: feedbackId, isLoading } = useQuery(
    trpc.feedback.feedbackId.queryOptions({
      shortId: decodeURIComponent(feedbackShortId),
    })
  )

  if (isLoading) {
    return <LoadingView />
  }

  if (!feedbackId && !isLoading) {
    return <Redirect href="/" />
  }

  return <Redirect href={`/feedback/${feedbackId}`} />
}
